import CloseIcon from '@mui/icons-material/Close';
import VerifiedIcon from '@mui/icons-material/Verified';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

import ResponsiveDialog from '@/components/ResponsiveDialog';

interface LogoutSuccessModalProps {
  open: boolean;
  sessionDuration: string;
  remainingSeconds: number;
  onClose: () => void;
  isLoading?: boolean;
}

const LogoutSuccessModal = ({
  open,
  sessionDuration,
  remainingSeconds,
  onClose,
  isLoading,
}: LogoutSuccessModalProps) => {
  return (
    <ResponsiveDialog
      fullScreenOnMobile={false}
      maxWidth='xs'
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          boxShadow: 'none',
        },
        '& .MuiDialog-paper': {
          borderRadius: '8px',
        },
      }}
      open={open}
      disableEscapeKeyDown
      aria-labelledby='logout-success-dialog-title'
    >
      <DialogTitle sx={{ pt: 1 }} id='logout-success-dialog-title'>
        <Box
          display='flex'
          py={1}
          px={0}
          justifyContent='space-between'
          alignItems='center'
        >
          <Box display='flex' alignItems='center' gap={1}>
            <Typography variant='h6'>Logged Out</Typography>
            <VerifiedIcon sx={{ color: '#29B84A' }} />
          </Box>
          <CloseIcon
            sx={{ opacity: 0.4, cursor: 'pointer' }}
            onClick={onClose}
          />
        </Box>
        <Box
          sx={{
            borderTop: '1px dashed rgba(223, 223, 223, 1)',
            borderBottom: '1px dashed rgba(223, 223, 223, 1)',
            width: 'calc(100% + 216px)',
            marginLeft: -24,
            mt: 1,
          }}
        />
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography textAlign='center' variant='body1' sx={{ mb: 1 }}>
            You have been successfully logged out. You have been logged in for
          </Typography>
          <Typography
            textAlign='center'
            variant='h3'
            sx={{ opacity: 0.6, fontSize: '24px', my: 1 }}
          >
            {sessionDuration}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 1,
          padding: 3,
          pt: 0,
          width: '100%',
        }}
      >
        <Button
          onClick={onClose}
          variant='outlined'
          fullWidth
          color='primary'
          disabled={isLoading}
        >
          Back to home - {remainingSeconds}s
        </Button>
        {/* <Button
          onClick={onLogin}
          variant='contained'
          fullWidth
          color='primary'
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size='1rem' color='inherit' /> : null
          }
        >
          Login again
        </Button> */}
      </DialogActions>
    </ResponsiveDialog>
  );
};

export default LogoutSuccessModal;
